export const GET_CHEMICAL_ANALYSIS_REQUEST = "GET_CHEMICAL_ANALYSIS_REQUEST";
export const GET_CHEMICAL_ANALYSIS_SUCCESS = "GET_CHEMICAL_ANALYSIS_SUCCESS";
export const GET_CHEMICAL_ANALYSIS_FAILURE = "GET_CHEMICAL_ANALYSIS_FAILURE";

export const DELETE_CHEMICAL_ANALYSIS_REQUEST = "DELETE_CHEMICAL_ANALYSIS_REQUEST";
export const DELETE_CHEMICAL_ANALYSIS_SUCCESS = "DELETE_CHEMICAL_ANALYSIS_SUCCESS";
export const DELETE_CHEMICAL_ANALYSIS_FAILURE = "DELETE_CHEMICAL_ANALYSIS_FAILURE";

export const CREATE_CHEMICAL_ANALYSIS_REQUEST = "CREATE_CHEMICAL_ANALYSIS_REQUEST";
export const CREATE_CHEMICAL_ANALYSIS_SUCCESS = "CREATE_CHEMICAL_ANALYSIS_SUCCESS";
export const CREATE_CHEMICAL_ANALYSIS_FAILURE = "CREATE_CHEMICAL_ANALYSIS_FAILURE";

export const EDIT_CHEMICAL_ANALYSIS_REQUEST = "EDIT_CHEMICAL_ANALYSIS_REQUEST";
export const EDIT_CHEMICAL_ANALYSIS_SUCCESS = "EDIT_CHEMICAL_ANALYSIS_SUCCESS";
export const EDIT_CHEMICAL_ANALYSIS_FAILURE = "EDIT_CHEMICAL_ANALYSIS_FAILURE";

export const UPLOADCSV_CHEMICAL_ANALYSIS_REQUEST = "UPLOADCSV_CHEMICAL_ANALYSIS_REQUEST";
export const UPLOADCSV_CHEMICAL_ANALYSIS_SUCCESS = "UPLOADCSV_CHEMICAL_ANALYSIS_SUCCESS";
export const UPLOADCSV_CHEMICAL_ANALYSIS_FAILURE = "UPLOADCSV_CHEMICAL_ANALYSIS_FAILURE";